import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { FindingAPI } from '../../lib/api';
import { settings } from '../../lib/settings';
import { render } from '../../lib/helpers';

import Loading from '../Components/Loading';
import Card from '../Components/Card';
import Timeline from '../Components/Timeline';
import Flyout from '../Components/Flyout';
import FindingDetail from '../Components/FindingDetail';

const API = {
  finding: new FindingAPI(),
};

class EventPageView extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.fetch = this.fetch.bind(this);
    this.update = this.update.bind(this);
    console.log(API);
  }

  componentDidMount() {
    this.fetch();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.orgId !== this.props.orgId) {
      this.fetch();
    }
  }

  fetch() {
    const { dispatch } = this.props;
    this.handleFetch().then((responses) => {
      dispatch({ type: 'PAGE_SUCCESS', responses });
    }).catch((error) => {
      dispatch({ type: 'PAGE_ERROR', error });
    });
  }

  async handleFetch() {
    // @XXX TODO: this whole file will probably re-done since full
    // page views of findings will not be a PageView (second menu-item)
    // const { dispatch, orgId, user } = this.props;
    // dispatch({ type: 'PAGE_FETCH' });
    // const promises = [
    //   // @XXX use orgId
    //   API.finding.get({
    //     personId: user.id,
    //     orgId: 'ffffffff-feed-beef-1337-c0ffee000001',
    //   }).then(({ data }) => {
    //     dispatch({ type: 'PAGE_DATA_PART', part: 'finding', data });
    //   }),
    // ];
    // return Promise.all(promises);
  }

  update(data = {}) {
    const { dispatch } = this.props;
    dispatch({ type: 'PAGE_DATA_PART', part: 'finding', data });
  }

  toggleScrollerOpen() {
    const newState = !this.state.scrollerOpen;
    settings.set('preferences.scrollerOpen', newState, true);
    this.setState({ scrollerOpen: newState });
  }

  render() {
    const {
      data = {},
      loading = false,
    } = this.props;

    const {
      assignableUsers = [{ // @TODO @XXX
        username: 'responder',
        firstname: 'Rey',
        lastname: 'Responda',
        role: 'responder',
      }, {
        username: 'analyst',
        firstname: 'Alice',
        lastname: 'Analysta',
        role: 'analyst',
      }, {
        username: 'analyst2',
        firstname: 'Alicia',
        lastname: 'Analysta',
        role: 'analyst',
      }, {
        username: 'analyst3',
        firstname: 'Alejandro',
        lastname: 'Analysto',
        role: 'analyst',
      }, {
        username: 'manager',
        firstname: 'Ollie',
        lastname: 'Operata',
        role: 'manager',
      }],
    } = data;

    const finding = data.finding ? data.finding[0] : {};

    /* eslint-disable */
    finding.subEvents = [
        {
            "type" : "text",
            "value" : "Blumira has identified a Mimikats attack on your network",
            "date" : "2018-07-06T20:28:11.201Z"
        },
        {
            "type" : "text",
            "value" : "Threat closed as valid threat",
            "user" : {
                "username" : "responder",
                "firstname" : "Rey",
                "lastname" : "Responda"
            },
            "date" : "2018-07-06T21:49:11.201Z"
        },
        {
            "type" : "text",
            "value" : "Confidence Escalated",
            "user" : {
                "username" : "responder",
                "firstname" : "Rey",
                "lastname" : "Responda"
            },
            "date" : "2018-07-06T23:12:15.201Z"
        },
        {
            "type" : "text",
            "value" : "Mitigation Workflow Completed",
            "user" : {
                "username" : "analyst",
                "firstname" : "Alice",
                "lastname" : "Analysta"
            },
            "date" : "2018-07-17T22:50:33.201Z"
        }
    ];
    /* eslint-enable */


    let loadingStyles = {
      height: '100%',
    };
    if (loading) {
      loadingStyles = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: '100%',
      };
    }

    return (
      <div
        className='event fill'
        style={{ ...loadingStyles }}
      >
        {loading &&
          <Loading />
        }
        {!loading &&
          <div
            className='row main-content'
            style={{
              height: '100%',
              margin: '0px',
              width: 'calc(100% - 396px)',
            }}
          >
            <div className='fill left-column'>
              <Card
                key={finding.id}
                inverted
                expanded
                finding={finding}
                update={this.update}
                assignableUsers={assignableUsers}
              />
              <div className='message'>
                <textarea
                  placeholder={render({
                    path: 'general',
                    value: 'messagePlaceholder',
                    html: false,
                    safe: true,
                  })}
                />

              </div>
              <div className='timeline-wrapper'>
                <div className='column-header'>Threat Timeline</div>
                <Timeline
                  finding={finding}
                />
              </div>
            </div>
            <Flyout handleClose={() => false} isStatic>
              <FindingDetail
                finding={finding || {}}
                assignableUsers={assignableUsers}
                update={this.update}
              />
            </Flyout>
          </div>
        }
      </div>
    );
  }
}

EventPageView.propTypes = {
  orgId: PropTypes.string.isRequired,
  getState: PropTypes.func.isRequired, // eslint-disable-line
  dispatch: PropTypes.func.isRequired, // eslint-disable-line
  applyFilter: PropTypes.func.isRequired, // eslint-disable-line
  data: PropTypes.shape({}),
  filters: PropTypes.shape({}), // eslint-disable-line
  loading: PropTypes.bool, // eslint-disable-line
  pageTitle: PropTypes.string, // eslint-disable-line
};

EventPageView.defaultProps = {
  data: {},
  filters: {},
  loading: false,
  pageTitle: '',
};

export default EventPageView;



// WEBPACK FOOTER //
// ./src/views/Pages/EventPageView.js